export default {
    setCurrentPage(state, currentPage) {
        state.currentPage = currentPage;
    },
    setLastPage(state, lastPage) {
        state.lastPage = lastPage;
    },
    setItemsPerPage(state, itemsPerPage) {
        state.itemsPerPage = itemsPerPage;
    },
    setPageOptions(state, pageOptions) {
        state.pageOptions = pageOptions;
    },
    setSearch(state, search) {
        state.searchQuery = search;
    }
};
